import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase-helper";
import { postCompanyLogin, postLogout } from "../../../helpers/backend-helper";
import { setAuthUser } from "../../../helpers/cookie-utils";
// import {
//   postFakeLogin,
//   postJwtLogin,
//   postSocialLogin,
// } from "../../../helpers/fakebackend_helper";

const fireBaseBackend = getFirebaseBackend();

function* loginUser({ payload: { user, history } }) {
  try {
    console.log("Login saga started with user:", user);
    console.log("History/navigate function:", history);
    
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.loginUser,
        user.email,
        user.password
      );
      yield put(loginSuccess(response));
      history("/dashboard");
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtLogin, {
        email: user.email,
        password: user.password,
      });
      setAuthUser(response);
      yield put(loginSuccess(response));
      history("/dashboard");
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeLogin, {
        email: user.email,
        password: user.password,
      });
      setAuthUser(response);
      yield put(loginSuccess(response));
      history("/dashboard");
    } else {
      // Default to company login API
      console.log("Using company login API");
      const response = yield call(postCompanyLogin, {
        email: user.email,
        company_code: user.company_code,
        password: user.password,
      });
      
      console.log("Login response:", response);
      
      if (response.success) {
        console.log("Login successful, dispatching loginSuccess");
        yield put(loginSuccess(response.user));
        
        // Navigate to dashboard after successful login
        console.log("Attempting navigation to /dashboard");
        if (typeof history === 'function') {
          history("/dashboard");
          console.log("Navigation called successfully");
        } else {
          console.error("History is not a function:", typeof history);
        }
      } else {
        throw new Error("Login failed");
      }
    }
  } catch (error) {
    console.error("Login Error:", error);
    yield put(apiError(error.message || "Login failed"));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(response));
    } else {
      // Use backend logout for company login
      yield call(postLogout);
      yield put(logoutUserSuccess());
    }
    history("/login");
  } catch (error) {
    console.error("Logout Error:", error);
    yield put(apiError(error.message || "Logout failed"));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);
  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
